import React, { useState } from 'react'
import { Row, Col, Form, Button, Spinner, Tabs, Tab } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import { GENDERS, CIVIL_STATUS, IDENTIFICATION_TYPES, STUDY_LEVELS, DEPARTMENTS, WORKCENTERS, LANGUAGES } from '../../constants/userOptions'

export default function UserForm({ state, handleInputChange, handleCheckboxChange, submit, disableEnableUsers, isAddingOrEditing, isRegistering}) {
    const { t } = useTranslation()

    const [key, setKey] = useState('personal')

    const renderOptions = (options) =>
        options.map(opt => (
            <option key={opt.value} value={opt.value}>
                {t(opt.label)}
            </option>
        ))

    return (
        <Form onSubmit={submit}>

            <Tabs activeKey={key} onSelect={(k) => setKey(k)} className="mb-3">

                {/* ================= PERSONALES ================= */}
                <Tab eventKey="personal" title={t('personales')}>
                    <Row>

                        <Col md={6}>
                            <Form.Label>{t('users.name')}</Form.Label>
                            <Form.Control name="firstname" value={state.firstname || ''} onChange={handleInputChange} />
                        </Col>

                        <Col md={6}>
                            <Form.Label>{t('users.lastname')}</Form.Label>
                            <Form.Control name="lastname" value={state.lastname || ''} onChange={handleInputChange} />
                        </Col>

                        <Col md={4}>
                            <Form.Label>{t('users.identificationType')}</Form.Label>
                            <Form.Select name="identificationType" value={state.identificationType || ''} onChange={handleInputChange}>
                                <option value="">{t('users.select')}</option>
                                {renderOptions(IDENTIFICATION_TYPES)}
                            </Form.Select>
                        </Col>

                        <Col md={8}>
                            <Form.Label>{t('users.identification')}</Form.Label>
                            <Form.Control name="dni" value={state.dni || ''} onChange={handleInputChange} />
                        </Col>

                        <Col md={6}>
                            <Form.Label>{t('users.nacionality')}</Form.Label>
                            <Form.Control name="nacionality" value={state.nacionality || ''} onChange={handleInputChange} />
                        </Col>

                        <Col md={6}>
                            <Form.Label>{t('users.civilStatus')}</Form.Label>
                            <Form.Select name="civilStatus" value={state.civilStatus || ''} onChange={handleInputChange}>
                                <option value="">{t('users.select')}</option>
                                {renderOptions(CIVIL_STATUS)}
                            </Form.Select>
                        </Col>

                        <Col md={4}>
                            <Form.Label>{t('users.gender')}</Form.Label>
                            <Form.Select name="gender" value={state.gender || ''} onChange={handleInputChange}>
                                <option value="">{t('users.select')}</option>
                                {renderOptions(GENDERS)}
                            </Form.Select>
                        </Col>

                        <Col md={4}>
                            <Form.Label>{t('users.birthDate')}</Form.Label>
                            <Form.Control type="date" name="birthday" value={state.birthday || ''} onChange={handleInputChange} />
                        </Col>

                        <Col md={6}>
                            <Form.Label>{t('users.email')}</Form.Label>
                            <Form.Control name="email" value={state.email || ''} onChange={handleInputChange} />
                        </Col>

                        <Col md={6}>
                            <Form.Label>{t('users.personalEmail')}</Form.Label>
                            <Form.Control name="personalEmail" value={state.personalEmail || ''} onChange={handleInputChange} />
                        </Col>

                        <Col md={4}>
                            <Form.Label>{t('users.phoneWork')}</Form.Label>
                            <Form.Control name="phoneWork" value={state.phoneWork || ''} onChange={handleInputChange} />
                        </Col>

                        <Col md={4}>
                            <Form.Label>{t('users.phone')}</Form.Label>
                            <Form.Control name="phone" value={state.phone || ''} onChange={handleInputChange} />
                        </Col>

                        <Col md={4}>
                            <Form.Label>{t('users.emergencyPhone')}</Form.Label>
                            <Form.Control name="emergencyPhone" value={state.emergencyPhone || ''} onChange={handleInputChange} />
                        </Col>

                    </Row>
                </Tab>

                {/* ================= DIRECCIÓN ================= */}
                <Tab eventKey="address" title={t('direccion')}>
                    <Row>

                        <Col md={12}>
                            <Form.Label>{t('users.address')}</Form.Label>
                            <Form.Control name="address" value={state.address || ''} onChange={handleInputChange} />
                        </Col>

                        <Col md={3}>
                            <Form.Label>{t('users.postalCode')}</Form.Label>
                            <Form.Control name="postalCode" value={state.postalCode || ''} onChange={handleInputChange} />
                        </Col>

                        <Col md={3}>
                            <Form.Label>{t('users.town')}</Form.Label>
                            <Form.Control name="town" value={state.town || ''} onChange={handleInputChange} />
                        </Col>

                        <Col md={3}>
                            <Form.Label>{t('users.province')}</Form.Label>
                            <Form.Control name="province" value={state.province || ''} onChange={handleInputChange} />
                        </Col>

                        <Col md={3}>
                            <Form.Label>{t('users.country')}</Form.Label>
                            <Form.Control name="country" value={state.country || ''} onChange={handleInputChange} />
                        </Col>

                    </Row>
                </Tab>

                {/* ================= LABORALES ================= */}
                <Tab eventKey="work" title={t('laborales')}>
                    <Row>

                        <Col md={4}>
                            <Form.Label>{t('users.department')}</Form.Label>
                            <Form.Select name="department" value={state.department || ''} onChange={handleInputChange}>
                                <option value="">{t('users.select')}</option>
                                {renderOptions(DEPARTMENTS)}
                            </Form.Select>
                        </Col>

                        <Col md={4}>
                            <Form.Label>{t('users.workCenter')}</Form.Label>
                            <Form.Select name="workcenter" value={state.workcenter || ''} onChange={handleInputChange}>
                                <option value="">{t('users.select')}</option>
                                {renderOptions(WORKCENTERS)}
                            </Form.Select>
                        </Col>

                        <Col md={4}>
                            <Form.Label>{t('users.studyLevel')}</Form.Label>
                            <Form.Select name="studyLevel" value={state.studyLevel || ''} onChange={handleInputChange}>
                                <option value="">{t('users.select')}</option>
                                {renderOptions(STUDY_LEVELS)}
                            </Form.Select>
                        </Col>

                        <Col md={4}>
                            <Form.Label>{t('users.contributionGroup')}</Form.Label>
                            <Form.Control name="contributionGroup" value={state.contributionGroup || ''} onChange={handleInputChange} />
                        </Col>

                        <Col md={4}>
                            <Form.Label>{t('users.professionalCategory')}</Form.Label>
                            <Form.Control name="professionalCategory" value={state.professionalCategory || ''} onChange={handleInputChange} />
                        </Col>

                        <Col md={4}>
                            <Form.Label>{t('users.contractCode')}</Form.Label>
                            <Form.Control name="contractCode" value={state.contractCode || ''} onChange={handleInputChange} />
                        </Col>

                        <Col md={4}>
                            <Form.Label>{t('users.socialSecurityNumber')}</Form.Label>
                            <Form.Control name="socialSecurityNumber" value={state.socialSecurityNumber || ''} onChange={handleInputChange} />
                        </Col>

                        <Col md={4}>
                            <Form.Label>{t('users.salaryRange')}</Form.Label>
                            <Form.Control name="salaryRange" value={state.salaryRange || ''} onChange={handleInputChange} />
                        </Col>

                        <Col md={4}>
                            <Form.Check
                                label={t('users.subrogated')}
                                checked={state.subrogated || false}
                                onChange={(e) =>
                                    handleInputChange({ target: { name: 'subrogated', value: e.target.checked } })
                                }
                            />
                        </Col>

                        <Col md={6}>
                            <Form.Label>{t('users.vacationApprover')}</Form.Label>
                            <Form.Control name="vacationApprover" value={state.vacationApprover || ''} onChange={handleInputChange} />
                        </Col>

                        <Col md={6}>
                            <Form.Label>{t('users.timeTrackingApprover')}</Form.Label>
                            <Form.Control name="timeTrackingApprover" value={state.timeTrackingApprover || ''} onChange={handleInputChange} />
                        </Col>

                    </Row>
                </Tab>

                {/* ================= BANCARIOS ================= */}
                <Tab eventKey="bank" title={t('bancarios')}>
                    <Row>

                        <Col md={4}>
                            <Form.Label>{t('users.accountHolder')}</Form.Label>
                            <Form.Control name="accountHolder" value={state.accountHolder || ''} onChange={handleInputChange} />
                        </Col>

                        <Col md={4}>
                            <Form.Label>{t('users.iban')}</Form.Label>
                            <Form.Control name="iban" value={state.iban || ''} onChange={handleInputChange} />
                        </Col>

                        <Col md={4}>
                            <Form.Label>{t('users.swift')}</Form.Label>
                            <Form.Control name="swift" value={state.swift || ''} onChange={handleInputChange} />
                        </Col>

                        <Col md={6}>
                            <Form.Label>{t('users.bank')}</Form.Label>
                            <Form.Control name="bank" value={state.bank || ''} onChange={handleInputChange} />
                        </Col>

                    </Row>
                </Tab>

                {/* ================= FORMACIÓN ================= */}
                <Tab eventKey="training" title={t('formacion')}>
                    <Row>

                        <Col md={6}>
                            <Form.Label>{t('users.officialEducation')}</Form.Label>
                            <Form.Control name="officialEducation" value={state.officialEducation || ''} onChange={handleInputChange} />
                        </Col>

                        <Col md={6}>
                            <Form.Label>{t('users.additionalTraining')}</Form.Label>
                            <Form.Control name="additionalTraining" value={state.additionalTraining || ''} onChange={handleInputChange} />
                        </Col>

                        <Col md={6}>
                            <Form.Label>{t('users.languages')}</Form.Label>
                            <Form.Control name="languages" value={state.languages || ''} onChange={handleInputChange} />
                        </Col>

                        <Col md={6}>
                            <Form.Label>{t('users.skills')}</Form.Label>
                            <Form.Control name="skills" value={state.skills || ''} onChange={handleInputChange} />
                        </Col>

                    </Row>
                </Tab>

                {/* ================= CONFIG ================= */}
                <Tab eventKey="config" title={t('configuracion')}>
                    <Row>

                        <Col md={6}>
                            <Form.Label>{t('users.language')}</Form.Label>
                            <Form.Select name="language" value={state.language || ''} onChange={handleInputChange}>
                                <option value="">{t('users.select')}</option>
                                {renderOptions(LANGUAGES)}
                            </Form.Select>
                        </Col>

                    </Row>
                </Tab>

                <Tab eventKey="apps" title={t('apps')}>
                    <Row>

                        <Col md={3}>
                            <Form.Check
                                type="checkbox"
                                label="Microsoft"
                                checked={true}
                                disabled
                            />
                        </Col>

                        {/* <Col md={3}>
                            <Form.Check
                                type="checkbox"
                                label="Odoo"
                                checked={state?.apps?.odoo || false}
                                onChange={(e) =>
                                    handleCheckboxChange({
                                        target: {
                                            name: "apps",
                                            value: {
                                                ...state.apps,
                                                odoo: e.target.checked
                                            }
                                        }
                                    })
                                }
                            />
                        </Col> */}

                        <Col md={3}>
                            <Form.Check
                                type="checkbox"
                                label="Sesame HR"
                                checked={state?.apps?.sesamehr || false}
                                onChange={(e) =>
                                    handleCheckboxChange({
                                        target: {
                                            name: "apps",
                                            value: {
                                                ...state.apps,
                                                sesamehr: e.target.checked
                                            }
                                        }
                                    })
                                }
                            />
                        </Col>

                        {/* <Col md={3}>
                            <Form.Check
                                type="checkbox"
                                label="iEazy"
                                checked={state?.apps?.iseazy || false}
                                onChange={(e) =>
                                    handleCheckboxChange({
                                        target: {
                                            name: "apps",
                                            value: {
                                                ...state.apps,
                                                iseazy: e.target.checked
                                            }
                                        }
                                    })
                                }
                            />
                        </Col> */}

                    </Row>
                </Tab>

            </Tabs>

            <Row className="mt-3">
                <Col className="d-flex justify-content-between">

                    {isAddingOrEditing === 'editing' && (
                        <Button variant={state.active ? "danger" : "success"} onClick={disableEnableUsers}>
                            {state.active ? t("users.disable") : t("users.enable")}
                        </Button>
                    )}

                    <Button variant="primary" type="submit" disabled={isRegistering}>
                        {isRegistering ? <Spinner size="sm" /> : t("users.register")}
                    </Button>

                </Col>
            </Row>

        </Form>
    )
}